define('SuiteCommerce.ItemBadges.BadgesList.View', [
  'Backbone',
  'itembadges_list.tpl',
  'itembadges_svg_bookmark.tpl',
  'itembadges_svg_diagonal_banner.tpl',
  'itembadges_svg_flag.tpl',
  'itembadges_svg_rectangle_banner.tpl',
  'itembadges_svg_tag.tpl',
  'itembadges_svg_tapered_banner.tpl'
], function ItemBadgesBadgesListView(
  Backbone,
  itembadgesListTpl,
  bookmark,
  diagonalBanner,
  flag,
  rectangleBanner,
  tag,
  taperedBanner
) {
  'use strict';
  return Backbone.View.extend({
    template: itembadgesListTpl,
    initialize: function initialize(options) {
      this.model = options.model;
      this.position = options.position;
      this.currentView = options.currentView;
    },
    calculateWeight: function calculateWeight() {
      var weight = this.model.get('weight');
      switch (weight) {
        case '1':
          this.model.set('textWeight', '300');
          break;
        case '2':
          this.model.set('textWeight', '400');
          break;
        case '3':
          this.model.set('textWeight', '600');
          break;
        case '4':
          this.model.set('textWeight', '700');
          break;
        default:
          this.model.set('textWeight', '400');
      }
    },
    selectTemplate: function selectTemplate() {
      var modifier = this.model.get('text').length * 8;
      var padding = this.currentView === 'plp' ? 5 : 10;
      var totalPadding = padding * 2;
      switch (this.model.get('shape').shape) {
        case 'Bookmark':
          this.defineBookmark(totalPadding, modifier);
          break;
        case 'Diagonal Banner':
          this.defineDiangonalBanner();
          break;
        case 'Flag':
          this.defineFlag(totalPadding, modifier);
          break;
        case 'Rectangle Banner':
          this.defineRectangleBanner(totalPadding, modifier);
          break;
        case 'Tag':
          this.defineTag(totalPadding, modifier);
          break;
        case 'Tapered Banner':
          this.defineTaperedBanner(totalPadding, modifier);
          break;
        default:
          if (!this.model.get('shape').image) {
            this.defineRectangleBanner(totalPadding, modifier);
          }
      }
    },
    defineBookmark: function defineBookmark(totalPadding, modifier) {
      var textSpace = totalPadding + modifier;
      var shape = this.calculateBookmarkShape(textSpace);
      this.model.set('svg',
        {
          width: textSpace + 34.5,
          shape: shape,
          textEnd: this.currentView === 'plp' ? textSpace : textSpace - 10,
          textStart: this.currentView === 'plp' ? 30 : 40,
          height: this.currentView === 'plp' ? 54 : 64
        });
      this.template = bookmark;
    },
    calculateBookmarkShape: function calculateBookmarkShape(textSpace) {
      var plpModifier = this.currentView === 'plp' ? 10 : 0;
      if (this.position.match('right')) {
        return 'M' + (textSpace + 1 + plpModifier) + ',0 L' + (textSpace + 1 + plpModifier) + ','+(62-plpModifier)+' L' + (textSpace + 18 + (plpModifier/2)) + ','+(55-plpModifier)+' L' + (textSpace + 35.5) + ','+(62-plpModifier)+' L' + (textSpace + 35.5) + ',0 L' + (textSpace + 79) + ',0 Z';
      }
      return 'M1,0 L1,'+(62-plpModifier)+' L'+(18-(plpModifier/2))+','+(55-plpModifier)+' L'+(35.5-(plpModifier))+','+(62-plpModifier)+' L'+(35.5-(plpModifier))+',0 L79,0 Z';
    },
    defineDiangonalBanner: function defineDiangonalBanner() {
      this.model.set('svg',
        {
          textCenter: this.currentView === 'plp' ? 18 : 23,
          height: this.currentView === 'plp' ? 25 : 35
        });
      this.template = diagonalBanner;
    },
    defineFlag: function defineFlag(totalPadding, modifier) {
      var additionalPixels = 7.5;
      var totalPixels = totalPadding + additionalPixels;
      var width = totalPixels + modifier;
      var textMiddle = this.calculateTextMiddle(totalPadding, modifier, additionalPixels);
      var textHeight = this.currentView === 'plp' ? 16.75 : 21.75;
      this.model.set('svg',
        {
          shape: 'M0,0 L' + (totalPixels + modifier) + ',0 L' + (totalPadding + modifier) + ','+(7.5+(totalPadding/2))+' L' + (totalPixels + modifier) + ','+(15+totalPadding)+' L0,'+(15+totalPadding)+' Z',
          width: width,
          textMiddle: textMiddle,
          textHeight: textHeight,
          height: totalPadding + 15
        });
      this.template = flag;
    },
    defineRectangleBanner: function defineRectangleBanner(totalPadding, modifier) {
      var width = totalPadding + modifier;
      var textMiddle = this.calculateTextMiddle(totalPadding, modifier);
      var textHeight = this.currentView === 'plp' ? 16.75 : 21.75;
      this.model.set('svg',
        {
          width: width,
          textMiddle: textMiddle,
          textHeight: textHeight,
          height: totalPadding + 15
        });
      this.template = rectangleBanner;
    },
    defineTag: function defineTag(totalPadding, modifier) {
      var additionalPixels = 14;
      var totalPixels = totalPadding + additionalPixels;
      var width = totalPixels + modifier;
      var textMiddle = this.calculateTextMiddle(totalPadding, modifier, additionalPixels);
      var textHeight = this.currentView === 'plp' ? 16.75 : 21.75;
      this.model.set('svg',
        {
          shape: 'M' + (totalPadding + modifier) + ',0 L' + (totalPixels + modifier) + ','+(7.5+(totalPadding/2))+' L' + (totalPadding + modifier) + ','+(15+totalPadding)+' L0,'+(15+totalPadding)+' L0,0 L' + (totalPadding + modifier) + ',0 Z',
          width: width,
          textMiddle: textMiddle,
          textHeight: textHeight,
          height: totalPadding + 15
        });
      this.template = tag;
    },
    defineTaperedBanner: function defineTaperedBanner(totalPadding, modifier) {
      var additionalPixels = 13;
      var totalPixels = totalPadding + additionalPixels;
      var width = totalPixels + modifier;
      var textMiddle = this.calculateTextMiddle(totalPadding, modifier, additionalPixels);
      var textHeight = this.currentView === 'plp' ? 16.75 : 21.75;
      this.model.set('svg',
        {
          shape: 'M0,0 L' + (totalPixels + modifier) + ',0 L' + (totalPadding + modifier) + ','+(15+totalPadding)+' L0,'+(15+totalPadding)+' Z',
          width: width,
          textMiddle: textMiddle,
          textHeight: textHeight,
          height: totalPadding + 15
        });
      this.template = taperedBanner;
    },
    calculateTextMiddle: function calculateTextMiddle(totalPadding, modifier, additionalPixels) {
      if (this.position.match('right') && additionalPixels) {
        return additionalPixels + ((totalPadding + modifier) / 2);
      }
      return (totalPadding + modifier) / 2;
    },
    flipVertical: function flipVertical() {
      return !!this.position.match('right');
    },
    getContext: function getContext() {
      var showText = !!this.model.get('text');
      var showImage = !!this.model.get('shape').image;
      this.selectTemplate();
      this.calculateWeight();
      return {
        model: this.model,
        name: this.model.get('name'),
        alt: this.model.get('alt'),
        showText: showText,
        text: this.model.get('text'),
        textColor: this.model.get('color') || '#FFFFFF',
        textBgColor: this.model.get('background'),
        textWeight: this.model.get('textWeight'),
        showImage: showImage,
        shapeId: this.model.get('shape').id,
        shapeName: this.model.get('shape').name,
        shapeImage: this.model.get('shape').image,
        areBothElementsVisibile: showText && showImage,
        svg: this.model.get('svg'),
        position: this.position,
        flipVertical: this.flipVertical(),
        isPlp: this.currentView === 'plp'
      };
    }
  });
});
